import Avatar from "components/Avatar";
import Logo from "components/Logo";

const Header = () => {
    return (
        <div className="flex flex-row pb-10">
            <Logo />
            <Avatar />
        </div>
    )
}

export default Header;